import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_CLASS_LEADERBOARDS_STATE = "class-leaderboards";

export const classLeaderboardsCrudStateConfig: CrudConfig = {
  name: "classLeaderboards",
  path: "seneca/classLeaderboards/meta",
  idFieldName: "classId",
  callTypes: [AllowedCallTypes.FETCH]
};
